var map = {
	"./20230713-Stufi-Max-07.20-03.mp3": 6967,
	"./20230713-Stufi-Max-07.21-04.mp3": 3703,
	"./20230713-Stufi-Max-07.23-05.mp3": 2636,
	"./20230713-Stufi-Max-07.24-06.mp3": 890,
	"./Noah - Kristel-09.21-39.mp3": 8915,
	"./Noah - Kristel-09.23-40.mp3": 4549,
	"./Noah - Kristel-09.25-41.mp3": 7082,
	"./Noah - Kristel-09.27-42.mp3": 4251,
	"./Noah - Kristel-13.1-43.mp3": 7619,
	"./Noah - Kristel-13.11-48.mp3": 8577,
	"./Noah - Kristel-13.3-44.mp3": 4946,
	"./Noah - Kristel-13.5-45.mp3": 1385,
	"./Noah - Kristel-13.7-46.mp3": 8916,
	"./Noah - Kristel-13.9-47.mp3": 6607,
	"./Studiefinanciering - Max-01.10-06.mp3": 9972,
	"./Studiefinanciering - Max-01.12-07.mp3": 643,
	"./Studiefinanciering - Max-01.14-08.mp3": 1062,
	"./Studiefinanciering - Max-01.2-02.mp3": 5503,
	"./Studiefinanciering - Max-01.4-03.mp3": 5864,
	"./Studiefinanciering - Max-01.6-04.mp3": 2069,
	"./Studiefinanciering - Max-02.1-09.mp3": 7820,
	"./Studiefinanciering - Max-02.5-11.mp3": 9315,
	"./Studiefinanciering - Max-03.1-12.mp3": 5163,
	"./Studiefinanciering - Max-04.3-01.mp3": 1664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7228;